import { createQueryKeys } from '@lukemorales/query-key-factory';
import { ProductService } from '../service';
export const productQueries = createQueryKeys('product', {
    offer: (productId) => ({
        queryKey: [productId],
        queryFn: () => ProductService.getOffer(productId)
    }),
    freeSignupStatus: (subdomain) => ({
        queryKey: [subdomain],
        queryFn: () => ProductService.getFreeSignupStatus(subdomain)
    })
});
